module.exports = function(bh) {
  bh.match('custom-file', function(ctx, json) {
    ctx.tParam('custom-file-id', ctx.generateId());
  });
};
